import React from "react";
import { PageHero, useSeo } from "../components/Shared";
import { COMPANY } from "../lib/site";

const H = ({ children }) => (
  <h2 className="mt-10 text-lg font-extrabold tracking-tight text-brand-black md:text-lg">{children}</h2>
);
const P = ({ children }) => <p className="mt-3 text-sm leading-relaxed text-brand-gray sm:text-base">{children}</p>;
const LI = ({ children }) => <li className="mt-2 text-sm leading-relaxed text-brand-gray sm:text-base">{children}</li>;

export default function Privacy() {
  useSeo("Privacy Policy | MJG Promotions", "How MJG Promotions collects, uses, and protects information submitted through mjgpromotions.com.");
  return (
    <>
      <PageHero eyebrow="Legal" title="Privacy Policy" intro="How we collect, use, and protect the information you share with us." />
      <section className="bg-white py-16 sm:py-20" data-testid="privacy-page">
        <div className="mx-auto max-w-3xl px-5">
          <p className="text-sm font-semibold text-brand-gray">Last updated: June 2026</p>
          <P>
            {COMPANY.name} ("MJG," "we," "us") operates {COMPANY.domain}. This policy explains what information we
            collect through this website, how we use it, and the choices you have. We are a business-to-business
            company located at {COMPANY.address}.
          </P>

          <H>Information We Collect</H>
          <P>We collect information you voluntarily provide when you submit our contact or consultation form:</P>
          <ul className="ml-5 list-disc">
            <LI>Name, company, email address, and phone number</LI>
            <LI>Details about your project, program, timeline, and estimated quantities</LI>
            <LI>Any file names or materials you reference in your inquiry</LI>
          </ul>
          <P>
            Like most websites, our hosting and analytics tools may automatically collect standard technical data such
            as browser type, device information, pages visited, and approximate location derived from IP address.
          </P>

          <H>How We Use Your Information</H>
          <ul className="ml-5 list-disc">
            <LI>To respond to your inquiry and prepare quotes or consultations you request</LI>
            <LI>To communicate with you about projects, orders, and services</LI>
            <LI>To operate, maintain, and improve this website</LI>
            <LI>To comply with legal obligations and protect our legal rights</LI>
          </ul>
          <P>We do not sell your personal information, and we do not use it for third-party advertising.</P>

          <H>How We Share Information</H>
          <P>
            We share information only with service providers who help us operate this website and respond to
            inquiries (for example, website hosting, database, and email delivery providers), and only as needed to
            perform those services. We may also disclose information if required by law or to protect our rights,
            property, or safety.
          </P>

          <H>Data Retention</H>
          <P>
            We retain inquiry records for as long as reasonably necessary to serve you, maintain business records, and
            meet legal requirements. You may request deletion of your inquiry data at any time using the contact
            details below.
          </P>

          <H>Cookies & Analytics</H>
          <P>
            This website may use cookies and similar technologies for basic functionality and aggregate usage
            analytics. You can control cookies through your browser settings; disabling them will not prevent you from
            using the site.
          </P>

          <H>Security</H>
          <P>
            We use commercially reasonable technical and organizational safeguards to protect the information you
            submit. No method of transmission or storage is completely secure, so we cannot guarantee absolute
            security.
          </P>

          <H>Children</H>
          <P>
            This website is intended for business audiences and is not directed to children under 16. We do not
            knowingly collect information from children.
          </P>

          <H>Your Choices & Rights</H>
          <P>
            You may request access to, correction of, or deletion of the personal information you have submitted to us.
            To make a request, email {" "}
            <a href={COMPANY.emailHref} className="font-semibold text-brand-red hover:underline">{COMPANY.email}</a>{" "}
            or call {COMPANY.phone}. We will respond within a reasonable timeframe and as required by applicable law.
          </P>

          <H>Changes to This Policy</H>
          <P>
            We may update this policy from time to time. The "Last updated" date above reflects the most recent
            revision. Continued use of the website after changes indicates acceptance of the updated policy.
          </P>

          <H>Contact</H>
          <P>
            {COMPANY.name}, {COMPANY.address} · {COMPANY.phone} ·{" "}
            <a href={COMPANY.emailHref} className="font-semibold text-brand-red hover:underline">{COMPANY.email}</a>
          </P>
        </div>
      </section>
    </>
  );
}
